/** Затемнение под шторкой публикации — только на телефоне (с `sm` окно — облачко).
 *  Клик по нему закрывает окно сам: это «мимо» для `useDismissPanel`. */
export const PublishSheetBackdrop = () => (
  <div
    aria-hidden="true"
    className="fixed inset-0 z-40 bg-background/60 backdrop-blur-[2px] duration-200 animate-in fade-in sm:hidden"
  />
)

/** Ручка-полоска шторки (телефон). */
export const PublishSheetHandle = () => (
  <div
    aria-hidden="true"
    className="-mt-2 mx-auto h-1 w-10 rounded-full bg-foreground/20 sm:hidden"
  />
)
